module.exports = __webpack_public_path__ + "img/049-ghost.c01f6a92.png";